import { ForgotPasswordMessages, TranslationForgotPasswordMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationForgotPasswordMessages = {
  [ForgotPasswordMessages.forgotPasswordRequiredEmail]: "Email is required",
  [ForgotPasswordMessages.forgotPasswordInvalidEmail]: "Invalid email",
  [ForgotPasswordMessages.forgotPasswordEmailLabel]: "Email",
  [ForgotPasswordMessages.forgotPasswordTitlePage]: "Forgot password",
  [ForgotPasswordMessages.forgotPasswordButton]: "Send email"
};
